<template>
  <p class="text-[0.625rem] leading-4 text-black1 md:text-sm"><slot /></p>
</template>
